export const halfOf50 = 'MTDLUV50'
export const tryNow33 = 'TRYNOW33'
export const lastChance50 = 'LASTCHANCE50'

export const promoCodes = {
	[halfOf50]: '50% off 1-month Premium Membership',
	[tryNow33]: '33% off 3-month Premium Membership',
	[lastChance50]: '50% off 2-month Premium Membership'
}
